import React, {
  Component
} from 'react';
const $=window.$;

export default class Ourclients extends Component {

  render() {
    return (
     <div className="clietns">
       <div className="row">
         <div className="our-clients">
           <h2>Our Clients</h2>
           <span className="line1"></span> </div>
         <ul className="client-menu">
           <li className="red"><a href="javascript:void();">Corporates</a>
             <div className="sub-menu">
               <ul>
                 <li><a href="#">Astra Zeneca</a></li>
                 <li><a href="#">Brakes India</a></li>
                 <li><a href="#">Career Launcher</a></li>
                 <li><a href="#">Cognizant Technology Solutions </a></li>
                 <li><a href="#">Covansys (CSC)</a></li>
                 <li><a href="#">GRO (Zenta)</a></li>
                 <li><a href="#">Kantar</a></li>
                 <li><a href="#">Manhattan Associates</a></li>
                 <li><a href="#">Nokia Siemens Networks</a></li>
                 <li><a href="#">Pearl Academy</a></li>
                 <li><a href="#">Redington Foundation</a></li>
                 <li><a href="#">SanDisk</a></li>
                 <li><a href="#">Visteon</a></li>
               </ul>
             </div>
           </li>
           <li className="blue"><a href="javascript:void();">Colleges</a>
             <div className="sub-menu">
               <ul>
                 <li><a href="#">Anna Adarsh College for Women</a></li>
                 <li><a href="#">B S Abdur Rahman University</a></li>
                 <li><a href="#">M A M College of Engineering </a></li>
                 <li><a href="#">Pearl Academy</a></li>
                 <li><a href="#">Rajalakshmi Engg College</a></li>
                 <li><a href="#">Rajalakshmi Instt of Technology</a></li>
                 <li><a href="#">S A Engineering College</a></li>
                 <li><a href="#">Sri Ramakrishna Mission Vidyalaya</a></li>
               </ul>
             </div>
           </li>
           <li className="orng"><a href="javascript:void();"> Institutions </a>
             <div className="sub-menu">
               <ul>
                 <li><a href="#">L V Prasad Eye Institute </a></li>
                 <li><a href="#">Sankara Nethralaya </a></li>
               </ul>
             </div>
           </li>
           <li className="rose"><a href="#" target="_blank"> ASPs</a>
             <div className="sub-menu">
               <ul>
                 <li><a href="#">Career Launcher</a></li>
                 <li><a href="#">CSC</a></li>
               </ul>
             </div>
           </li>
           <li className="grn"><a href="javascript:void();"> Government</a>
             <div className="sub-menu">
               <ul>
                 <li><a href="#">Election Commission of India</a></li>
               </ul>
             </div>
           </li>
         </ul>
       </div>
     </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/partials/Ourclients.js